import StarRating from './star-rating/star-rating-directive';
import NegotiatedRate from './negotiated-rate/negotiated-rate-component';
import ContentTogglerModule from './content-toggler/content-toggler-module';
import ListExpander from './list-expander/list-expander-component';
import Radio from './radio';
import Switcher from './switcher/switcher-module';
import SpinnerService from './spinner-service';

import TooltipIcon from './tooltip-icon/tooltip-icon-module';
import TogglerModule from './toggler/toggler-module';
import ToggleButtonModule from './toggle-button/toggle-button-module';
import DropdownSelectModule from './dropdown-select/dropdown-select-module';
import UkRailCardsModule from './ukrail-cards/ukrail-cards-module';
import EuRailCardsModule from './eurail-cards/eurail-cards-module';
import VersionUpgradeModule from './version-upgrade/version-upgrade-module';

const MODULE_NAME = 'App.common.widgets';
const module = angular.module(MODULE_NAME, [
        TooltipIcon,
        TogglerModule,
        ToggleButtonModule,
        DropdownSelectModule,
        UkRailCardsModule,
        EuRailCardsModule,
        ContentTogglerModule,
        VersionUpgradeModule,
        Switcher,
    ])
    .directive(StarRating.DIRECTIVE_NAME, StarRating)
    .directive(NegotiatedRate.DIRECTIVE_NAME, NegotiatedRate)
    .directive(Radio.DIRECTIVE_NAME, Radio)
    .directive(ListExpander.DIRECTIVE_NAME, ListExpander)
    .service('spinnerService', SpinnerService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/widgets-module.js